import { Route } from 'react-router-dom'

import { QuestRenderer } from './QuestRenderer'

export default (
  <Route key="sticker">
    <Route path="/quest/:questId" element={<QuestRenderer />} />
  </Route>
)
